import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  IconButton,
} from "@mui/material";

import {
  LuChevronDown,
  LuSearch,
  LuTrash2,
  FiEdit2,
} from "@/Components/Icons/Icons";
import Dropdown from "@/Components/Form/InputDropdown";
import InputField from "@/Components/Form/InputTextField";
import DateSelector from "@/Components/Form/DateSelector";
import DateTimePicker from "../../Components/Form/DateTimePicker";
import CheckboxBox from "../Form/CheckboxBox";
import { BiBorderRadius } from "react-icons/bi";

// 🔧 Dynamic Input Renderer
const renderDynamicInput = (
  fieldTypes,
  values,
  options = [],
  disabledList = [],
  maxDateToTodayList=[],
  showIconList = [],
  labels = [],
  widths = [],
  names = [], // ✅ Add this
  row,
  onDelete,
  onEdit,
  verticalAlign = "middle",
  onChange,
  colkey,
  cellData, // ⭐ ADD THIS,
  height
) => {
  const elements = [];
  const types = Array.isArray(fieldTypes) ? fieldTypes : [];
  const valArray = Array.isArray(values) ? values : [];
  const disabledArray = Array.isArray(disabledList) ? disabledList : [];
  const maxDateToTodayArray = Array.isArray(maxDateToTodayList) ? maxDateToTodayList : [];
  const iconArray = Array.isArray(showIconList) ? showIconList : [];
  const labelArray = Array.isArray(labels) ? labels : [];
  const widthArray = Array.isArray(widths) ? widths : [];
  const nameArray = Array.isArray(names) ? names : [];

  types.forEach((type, idx) => {
    if (!type) return;
    const value = valArray[idx] ?? "";
    const disabled = disabledArray[idx] ?? false;
    const maxDateToToday = maxDateToTodayArray[idx] ?? false;
    const showSearchIcon = iconArray[idx] ?? false;
    const label = labelArray[idx] ?? "";
    const width = widthArray[idx] || `${100 / types.length}%`;
    const name = nameArray[idx] || `${colkey}-${idx}-${type}`;

    let inputEl;

    switch (type) {
      case "dropdown":
        // const currentValue = row[colkey]?.name || row[colkey].value || "";
        const currentValue = Array.isArray(row[colkey]?.value)
          ? typeof row[colkey].value[0] === "object"
            ? (row[colkey].value[0].name ?? "") // pick id for dropdown value
            : row[colkey].value[0]
          : "";
        const selectedOption = options.find(
          (opt) => opt.value === currentValue
        );
        inputEl = (
          <Dropdown
            options={options}
            icon={<LuChevronDown />}
            value={currentValue}
            // onChange={(newVal) =>
            //   onChange?.({ rowId: row.id, key: colkey, value: [newVal] })
            // }
            onChange={(newVal) => {
              if (typeof onChange === "function") {
                const valToStore = Array.isArray(newVal) ? newVal[0] : newVal;
                onChange({ rowId: row.id, key: colkey, value: valToStore });
              }
            }}
            placeholder="Select"
            fullWidth
            gap={false}
            disabled={disabled}
            sx={{
              "& .MuiInputBase-root": {
                width: "100%",
                height: "35px !important",
              },
            }}
            {...(label ? { label } : {})}
          />
        );
        break;
      case "checkbox":
        inputEl = (
          <CheckboxBox
            checkboxLabel={label}
            value={value}
            disabled={disabled}
            onChange={(newVal) => {
              onChange?.({
                rowId: row.id,
                key: colkey,
                value: newVal,
              });
            }}
            sx={{ width }}
          />
        );
        break;

      case "display": // ✅ new type for plain text
        inputEl = (
          <Box
            sx={{
              width,
              height: "34px",
              display: "flex",
              alignItems: "center",
              pl: 0.5,
            }}
          >
            {value}
          </Box>
        );
        break;
      case "DateSelector":
        inputEl = (
          <DateSelector
            value={value}
            fullWidth
            disabled={disabled}
            sx={{
              "& .MuiInputBase-root": {
                width: width,
                height: "37px !important",
              },
            }}
            {...(label ? { label } : {})}
          />
        );
        break;
      case "DatetimeSelector":
        inputEl = (
          <DateTimePicker
            value={value}
            fullWidth
            gap={false}
            maxDateToToday={maxDateToToday}
            // placeholder={placeholder}
            disabled={disabled}
            sx={{
              "& .MuiInputBase-root": {
                width: width,
                height: "37px !important",
              },
            }}
            {...(label ? { label } : {})}
          />
        );
        break;

        case "action":
          inputEl = (
            <Box display="flex" alignItems="center" gap={1}>
              {/* ✅ ALWAYS SHOW EDIT */}
              <IconButton
                onClick={() => onEdit(row)}
                sx={{ color: "var(--brand-600)" }}
              >
                <FiEdit2 />
              </IconButton>
        
              {/* ✅ DELETE ONLY IF onlyEdit !== true */}
              {!cellData?.onlyEdit && (
                <IconButton
                  onClick={() => onDelete(row)}
                  sx={{ color: "var(--brand-600)" }}
                >
                  <LuTrash2 />
                </IconButton>
              )}
            </Box>
          );
          break;
        

      // Special characters → Box display only
      case "/":
      case "Or":
      case "Rs":
      case "%":
      case "Unit":
        inputEl = (
          <Box
            sx={{
              width,
              height: "34px",
              mt: 3.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              pl: 0.5,
            }}
          >
            {type}
          </Box>
        );
        break;

      default:
        inputEl = (
          <InputField
            id={name}
            name={name}
            type={type}
            value={value || ""}
            dataType={cellData?.dataType}
            sx={{
              "& .MuiInputBase-root": {
                width: width,
                height: "30px !important",
              },
            }}
            onChange={(e) => {
              const val = e.target?.value ?? e; // handles both input and direct value
              if (typeof onChange === "function") {
                onChange({
                  rowId: row.id,
                  key: colkey,
                  value: val, // ✅ store primitive, not array
                  name,
                });
              } else {
                console.warn("⚠️ onChange is not a function:", onChange);
              }
            }}
            gap={false}
            placeholder="00.00"
            disabled={disabled}
            icon={showSearchIcon ? LuSearch : undefined}
            {...(label ? { label } : {})}
          />
        );
        break;
    }

    elements.push(
      <Box
        key={`${colkey}-${idx}-${type}`}
        sx={{ width, display: "flex", alignItems: "center" }}
      >
        {inputEl}
      </Box>
    );
  });

  return (
    <Box display="flex" alignItems="center" gap={0}>
      {elements}
    </Box>
  );
};

// ✅ DynamicCessTable
const DynamicCessTable = ({
  rowData,
  columnFields,
  dropdownOptions,
  onDelete,
  onEdit,
  onChange,
  height,
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        maxHeight: height || 350, // Set max height for vertical scroll
        overflowY: "auto",
        overflowX: "auto",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: "var(--brand-100)" }}>
            {columnFields.map((col) => (
              <TableCell
                key={col.key}
                sx={{
                  width: col.width,
                  maxWidth: col.width,
                  minWidth: col.width,
                  borderRight: "3px solid var(--gray-0)",
                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                  height: 50,
                  position: "sticky",
                  top: 0,
                  zIndex: 2, // ensures header is above body
                  backgroundColor: "var(--brand-100)", // needed for sticky
                }}
              >
                <Typography variant="bodySmall">{col.label}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rowData.map((row) => (
            <TableRow
              key={row.id}
              sx={{
                borderBottom: "1px solid var(--gray-200)",
                height: 32, // ✅ ROW HEIGHT REDUCED
                maxHeight: 32,
              }}
            >
              {columnFields.map((col) => {
                const cell = row[col.key] ||  row[col.key]?.value?.[0] || {};
                const inputType = cell.type || [];
                const value = cell.value || [];
                const disabled = cell.disabled || [];
                const maxDateToToday =cell.maxDateToToday || false;
                const showSearchIcon = cell.showSearchIcon || [];
                const label = cell.label || [];
                const width = cell.width || [];
                const names = cell.name || []; // ✅ added names
                const hasDropdown = inputType.includes("dropdown");
                const options = hasDropdown
                  ? cell.options || dropdownOptions
                  : [];

                return (
                  <TableCell
                    key={col.key}
                    sx={{
                      verticalAlign: col.verticalAlign || "bottom",
                      overflow: "visible",
                      alignContent: "center !important",
                    }}
                  >
                    {renderDynamicInput(
                      inputType,
                      value,
                      options,
                      disabled,
                      maxDateToToday,
                      showSearchIcon,
                      label,
                      width,
                      names, // ✅ pass names here
                      row,
                      onDelete,
                      onEdit,
                      col.verticalAlign || "middle",
                      onChange,
                      col.key,
                      cell // ⭐ PASS CELL HERE
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DynamicCessTable;
